import React, { useEffect, useState, useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import SimpleCountCard from 'components/cards/SimpleCountCard';
import { AppContext } from 'store/AppContext';
import { getAtkvaediCounts } from 'common/services/apiService';


const AtkvaediCountSection = () => {
  const context = useContext(AppContext);
  const [atkvaediCounts, setAtkvaediCounts] = useState({});

  const kosningId = context.activeKosning.get.id;

  useEffect(() => {
    async function fetchAtkvaediCounts() {
      const { data, isSuccess, error } = await getAtkvaediCounts(kosningId, {}, context, {});

      if (isSuccess) {
        setAtkvaediCounts(data);
      } else {
        console.log(error);
        setAtkvaediCounts({});
      }
    }
    
    fetchAtkvaediCounts();
  }, [kosningId, context]);

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <SimpleCountCard
            title={"ATKVÆÐI Í DAG"}
            count={atkvaediCounts.today}
            avatarLetter={"D"}
          />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <SimpleCountCard
            title={"ATKVÆÐI Í GÆR"}
            count={atkvaediCounts.yesterday}
            avatarLetter={"G"}
          />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <SimpleCountCard
            title={"ATKVÆÐI Í VIKUNNI"}
            count={atkvaediCounts.currentWeek}
            avatarLetter={"V"}
          />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <SimpleCountCard
            title={"HEILDARFJÖLDI"}
            count={atkvaediCounts.total}
            avatarLetter={"H"}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default AtkvaediCountSection;